// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__nBlwc","hidden":"Menu_hidden__sza8i"};